<script lang="ts">
    import axios from 'axios';
    import Shgrid from '../../components/shgrid/shgrid.svelte';
    import type {Column} from '@/components/shgrid';
    import type {Documents} from  "@/types/types";
    import {SvelteSet} from "svelte/reactivity";

    type Row = Documents;

    type Props = {
        view : string;
        onRowClick?: (row: Row) => void;
        relatedData?: Record<string, any>;
    };

    let {view, onRowClick, relatedData }: Props = $props();


    const getRowLink = (row: Row) => route('documents.show', {document: row.id});
    const includeLink = view != 'related';
    let cols = $state<Column<Row>[]>([
        {
            label: 'Title',
            key: 'title',
            cellRender: {
                type: 'text',
                label: (row) => row.title,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'File name',
            key: 'filename',
            cellRender: {
                type: 'text',
                label: (row) => row.filename ?? "",
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Status',
            key: 'status',
            cellRender: {
                type: 'text',
                label: (row) => row.status,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Related To',
            key: 'vehicle',
            cellRender: {
                type: 'text',
                label: (row) => row.related_record_module + ": " + row.related_record_label,
                link: (row) =>  row.related_record_link
                    ? row.related_record_link
                    : undefined,
                highlightLink: true
            },
            sortable: true,
            filter: {
                type: null,
            },
        },
        {
            label: 'Created At',
            key: 'created_at',
            cellRender: {
                type: 'date',
                label: (row) => row.created_at,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'date',
            },
        },
    ]);

    // let selected = $state(new SvelteSet());
</script>

<div>
    <Shgrid
        fetcher={async ({ limit, offset, filters, sorter }) => {
            if (view === 'relatedList' && relatedData) {
                let relatedColumn = relatedData.column ;
                let related_record_id = relatedData.record_id;
                filters = { ...filters, [relatedColumn] : related_record_id };
            }
        const res = await axios.get(route('web-api.Document.index', { limit, offset, filters, sorter }));
        return { data: res.data, error: null };
    }}
        limit={100}
        bind:columns={cols}
        {...(view === 'related' ? { onRowClick } : {})}
    ></Shgrid>
</div>

